export default {
  redirectToInternal (vueInstance, name, params = {}) {
    if (!vueInstance) return false
    if (!vueInstance._isVue) return false

    if (name) {
      vueInstance.$router.push({ name, params })
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/assets/modules/routing/routingHelper.js